import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import WhatsAppAPI from '../../api/WhatsAppAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';

class InnerWhatsAppList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).whatsapp;
    this.state = { inApiCall: true, whatsapps: [] };
    this.WhatsAppCount = 0;
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() { this.loadWhatsApps(this.props.id); }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, whatsapps: [] });
      this.loadWhatsApps(props.id);
    }
  }

  loadWhatsApps = id => { WhatsAppAPI.getInnerList(this.props.type, id, this.onReceived, this.onFail); };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.WhatsAppCount = res.count ? res.count : 0;
    if (this.props.onCount)
      this.props.onCount('whatsapp', this.WhatsAppCount);

    this.setState({ inApiCall: false, whatsapps: res.data });
  };
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      WhatsAppAPI.delete(this.state.whatsapps[indx].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'WhatsApp Message deleted successfully', 'success');
    this.props.reload();
  };

  showList = () => this.state.whatsapps.map((whatsapp, _i) => (
    <tr key={`whatsapp_${_i + 1}`}>
      <td>{Util.serverStringToDisplayDateTime(whatsapp.created_date)}</td>
      <td>{Display.FieldValue(whatsapp, 'type', this.model.fields)}</td>
      <td>{Display.FieldValue(whatsapp, 'phone', this.model.fields)}</td>
      <td>{Display.ModelLabelValue('user', whatsapp.created_by)}</td>
      <td>{Display.FieldValue(whatsapp, 'text', this.model.fields)}</td>
      <td>{Display.FieldValue(whatsapp, 'response', this.model.fields)}</td>
      {/*
      <td>
        { this.Delete &&
          <span onClick={() => this.onDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
        }
      </td>
      */}
    </tr>
  ));

  render() {
    let uiWhatsapps = this.showList();
    if (this.state.whatsapps.length === 0) uiWhatsapps = <tr><td colSpan="6">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>{this.model.model_name} ({this.WhatsAppCount})</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Date Time</th>
                  <th>Type</th>
                  <th>Phone</th>
                  <th>Sales Person</th>
                  <th>Text</th>
                  <th>Response</th>
                  {/*<th className="actionth">Action</th>*/}
                </tr>
              </thead>
              <tbody>
                {uiWhatsapps}
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default InnerWhatsAppList;